import React, { useContext, useState, useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  customStyle,
  getSystemSettings,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from "moment";
import Select from "react-select";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useReactToPrint } from "react-to-print";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { UserContext } from "../../../../contexts/User";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";
import ReportExcelPrintGap from "../../../components/Reports/ReportExcelPrintGap";

let groupArr = [
  // { id: 1, name: "Document No" },
  { id: 2, name: "Document Date" },
  { id: 3, name: "Branch" },
  { id: 4, name: "Type" }
];

const ClosingStockReport = () => {
  const { t } = useTranslation();
  // const history = useHistory();
  //getting context values here
  let {
    loading,
    setLoading,
    dataPaginating,
    setDataPaginating,
    generalSettings,
  } = useContext(SettingsContext);
  const { authUserInfo } = useContext(UserContext);
  const { branchForSearch } = useContext(RestaurantContext);

  //all data
  const [reportData, setReportData] = useState(null);
  const componentRef = useRef();
  const componentRefThermal = useRef();
  const componentRefThermal1 = useRef();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [branch, setBranch] = useState(null);
  const [group, setGroup] = useState(groupArr[1]);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [option, setOption] = useState("excel");
  const [reportOption, setReportOption] = useState("detail");
  
  let common_toast = {
    position: "bottom-center",
    closeButton: false,
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  const handleSetType = (e) => {
    setReportOption(e.target.value)
  }

  const handleOption = (e) => {
    setOption(e.target.value);
  };

  const thermalPrint = useReactToPrint({
    content: () => componentRefThermal.current,
    pageStyle: `
        @page {
          margin: 15px 7px;
        }
      `,
  });

  const thermalPrintConsolidate = useReactToPrint({
    content: () => componentRefThermal1.current,
    pageStyle: `
        @page {
          margin: 15px 7px;
        }
      `,
  });

  //get excel reports filter
  const getExcelReport = () => {
    setReportData(null);
    setGeneratedReport(false);
    if (startDate !== null && endDate !== null && group !== null && (reportOption === "summary" || reportOption === "consolidated_summary" || branch)) {
      getReport();
    } else {
      toast.error(
        `${_t(t("Please select from date, to date, group and branch"))}`,
        common_toast
      );
    }
  };

  //get sale inv report
  const getReport = async () => {

    if (
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
      !branch?.[0]?.id
    ) {
      toast.error(`${_t(t("Please select branch to generate report"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }

    let fromDate = moment(startDate).format("YYYY-MM-DD");
    let toDate = moment(endDate).format("YYYY-MM-DD");
    const urlMap = {
      detail: "/settings/closing-stock-report-between",
      summary: "/settings/closing-stock-summary",
      consolidated_summary: "/settings/closing-stock-consolidated-summary"
    };
    const endPoint = urlMap[reportOption] || urlMap.detail;
    const url = BASE_URL + endPoint;
    setDataPaginating(true);
    const multiBranch = (branch && branch?.length) ? JSON.stringify(branch.map((branch) => branch.id)) : "";
    let formData = new FormData();
    formData.append("fromDate", fromDate);
    formData.append("toDate", toDate);
    formData.append("branch_id", multiBranch);
    formData.append("group_by", group.name);

    return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setGeneratedReport(true);
        const isConsolidateReport = reportOption === "consolidated_summary";
        const data = isConsolidateReport ? res.data.data : res.data
        setReportData(data);
        setDataPaginating(false);
        if (option === "excel") {
          componentRef.current.handleDownload();
        } else {
          if(isConsolidateReport){
            thermalPrintConsolidate()
          }else{
            thermalPrint();
          }
        }
      })
      .catch((error) => {
        setDataPaginating(false);
        toast.error(`${_t(t("Please try again"))}`, common_toast);
      });
  };

  const header = [
    { name: "Group Name", key: "grp" },
    // { name: "Document Id", key: "document_identity", gap:1 },
    { name: "Date", render: (item) => <Moment format="LL">{item.document_date}</Moment> },
    { name: "Branch", key: "branch_name" },
    { name: "Group Name", key: "group_name" },
    { name: "Item Name", key: "name" },
   
    { name: "Opening", key:"Opening", total: 1},
    { name: "Purchase", key:"Purchase" ,total: 1},
    { name: "Production", key:"Production" ,total: 1},
    { name: "ProductionInn", key:"ProductionInn" ,total: 1},
    { name: "TrasferInn", key:"TrasferInn" ,total: 1},
    { name: "TrasferOut", key:"TrasferOut" ,total: 1},
    { name: "Sales", key:"Sales" ,total: 1},
    { name: "MadeVoid", key:"MadeVoid" ,total: 1},
    { name: "Discard", key:"Discard" ,total: 1},
    { name: "Adjust", key:"Adjust", total: 1},
    { name: "Physical Count", key:"PhysicalEndCount" ,total: 1},
    { name: "Diff", key:"diff", render:(item)=> {
      const stockIn = Number(item.Opening) + Number(item.Purchase) + Number(item.Production) + 
        Number(item.ProductionInn) + Number(item.TrasferInn) + Number(item?.Adjust || 0);
      const stockOut = Number(item.TrasferOut) + Number(item.Sales) + Number(item.MadeVoid) + Number(item.Discard);
      const totalSystem = stockIn - stockOut;
      return (Number(item.PhysicalEndCount) - totalSystem).toFixed(3)
    } ,total: 1},
    { name: "Unit", key: "unit", style: { textAlign: "right" } },
    { name: "Last Purchase Rate", key: "last_purchase_rate", render: (item) => item.last_purchase_rate ?? item.last_purchase_price ?? item.purchase_rate ?? item.rate ?? 0 },
  ];

  const headerSummary = [
    { name: "Group Name", key: "grp" },
    { name: "Item Name", key: "name" },
    { name: "Opening", key: "Opening", total: 1 },
   
    // { name: "Production", key: "Production", total: 1 },
    // { name: "ProductionInn", key: "ProductionInn", total: 1 },
    { name: "TrasferInn", key: "TrasferInn", total: 1 },
    { name: "TrasferOut", key: "TrasferOut", total: 1 },
    { name: "Sales", key: "Sales", total: 1 },
    { name: "Adjust", key: "Adjust", total: 1 },
    { 
      name: "Balance", key: "balance", render: (item) => {
        const stockIn = Number(item.Opening) + Number(item.TrasferInn) + Number(item?.Adjust || 0);
        const stockOut = Number(item.TrasferOut) + Number(item.Sales);
        const totalSystem = stockIn - stockOut;
        return (totalSystem).toFixed(3)
      },
    },
    { name: "Physical Count", key: "PhysicalEndCount", total: 1 },
    {
      name: "Diff", key: "diff", render: (item) => {
        const stockIn = Number(item.Opening) + Number(item.Purchase) + Number(item.Production) +
          Number(item.ProductionInn) + Number(item.TrasferInn) + Number(item?.Adjust || 0);
        const stockOut = Number(item.TrasferOut) + Number(item.Sales) + Number(item.MadeVoid) + Number(item.Discard);
        const totalSystem = stockIn - stockOut;
        return (Number(item.PhysicalEndCount) - totalSystem).toFixed(3)
      }, total: 1
    },
    { name: "Unit", key: "unit", style: { textAlign: "end" } },
    { name: "Last Purchase Rate", key: "last_purchase_rate", render: (item) => item.last_purchase_rate ?? item.last_purchase_price ?? item.purchase_rate ?? item.rate ?? 0 },
  ];

  const tableHeading = () => (
    <>
      <h3 className="text-center xslg-text my-2">
        {getSystemSettings(generalSettings, "siteName")}
      </h3>
      <h3 className="text-center xslg-text my-2">
        Closing Stock Consolidated Summary
      </h3>
      <p className="text-center my-2">
        {branch && branch.length > 0 ? branch.map((item) => item.name).join(", ") : "All Branches"}
      </p>
      <p className="text-center my-2">
        {startDate && endDate ? (
          <>
            FROM&nbsp;
            <Moment format="LL">{startDate}</Moment>
            &nbsp;TO&nbsp;
            <Moment format="LL">{endDate}</Moment>
          </>
        ) : (
          <>
            Date&nbsp;
            <Moment format="LL">{startDate}</Moment>
          </>
        )}
      </p>
    </>
  );

  const getDiffAmount = (key, value) => {
    const addKeys = {
      Opening: 1,
      Purchase: 1,
      Production: 1,
      TrasferInn: 1,
      ProductionInn: 1,
    }
    const subKeys = {
      MadeVoid: 1,
      Discard: 1,
      PhysicalEndCount: 1,
      TrasferOut: 1,
    }
    const amount = Number(value) || 0;
    if (addKeys[key]) {
      return amount;
    } else if (key === "Total Sales" || subKeys[key]) {
      return -amount;
    }
    return 0;
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Closing Stock Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename={"Closing Stock Report"}
        sheet="sheet 1"
        buttonText="Fg Sale Detail"
        ref={componentRef}
      />

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating} />

                    {/* spin loading ends */}

                    <div key="smtp-form">
                      <div className="gx-2 align-items-center t-pt-15 t-pb-15">
                        <div className="row t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb col-6">
                            <li className="fk-breadcrumb__list">
                              <span className="pl-3 t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Closing Stock Report"))}
                              </span>
                            </li>
                          </ul>
                          <div className="col-6 d-flex justify-content-end">
                            <ReportTypeOptions
                              selectedOption={option}
                              onChange={handleOption}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div className="col-2 d-md-block">
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("From date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>

                        <div className="col-2 d-md-block">
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control"
                            placeholderText={_t(t("To date"))}
                            shouldCloseOnSelect={false}
                          />
                        </div>
                        <div className="col-3">
                          <Select
                            options={branchForSearch || []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={branch}
                            styles={customStyle}
                            isClearable
                            isMulti
                            classNamePrefix="select"
                            className="table-text"
                            onChange={(branch) => setBranch(branch)}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select branch")) + ".."}
                          />
                        </div>
                        
                        <div className="col-2">
                          <Select
                            options={groupArr && groupArr}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={group}
                            styles={customStyle}
                            isClearable
                            classNamePrefix="select"
                            className="table-text"
                            onChange={(group) => setGroup(group)}
                            maxMenuHeight="200px"
                            placeholder={_t(t("Select group")) + ".."}
                          />
                        </div>

                        <div className="col-3 d-flex align-items-start">
                          <div className="btn-group w-100 shadow-sm" role="group">
                            <button
                              type="button"
                              className={`btn btn-sm ${reportOption === "detail" ? "btn-primary font-weight-bold" : "btn-outline-primary"}`}
                              onClick={() => setReportOption("detail")}
                              style={{ borderTopLeftRadius: "6px", borderBottomLeftRadius: "6px" }}
                            >
                              {_t(t("Detail"))}
                            </button>
                            <button
                              type="button"
                              className={`btn btn-sm ${reportOption === "summary" ? "btn-primary font-weight-bold" : "btn-outline-primary"}`}
                              onClick={() => setReportOption("summary")}
                            >
                              {_t(t("Summary"))}
                            </button>
                            <button
                              type="button"
                              className={`btn btn-sm ${reportOption === "consolidated_summary" ? "btn-primary font-weight-bold" : "btn-outline-primary"}`}
                              onClick={() => setReportOption("consolidated_summary")}
                              style={{ borderTopRightRadius: "6px", borderBottomRightRadius: "6px" }}
                            >
                              {_t(t("Consolidated"))}
                            </button>
                          </div>
                        </div>
                        
                        <div className="col-10 mt-2"></div>
                        <div className="col-2 mt-2 t-mb-15 mb-md-0 text-right">
                          <button
                            className="ml-1 btn btn-block btn-primary sm-text py-2 rounded"
                            onClick={(e) => getExcelReport()}
                          >
                            GENERATE REPORT
                          </button>
                        </div>
                      </div>
                      <div className="row mt-2">

                        <div className="col"></div>

                      </div>
                      {reportOption === "consolidated_summary" ? (
                        generatedReport && (
                          <div className="d-none">
                            <div className="table-responsive bg-white mt-3" ref={componentRefThermal1}>
                              {reportData && reportData.length > 0 ? (
                                <>
                                {option !== "excel" && tableHeading()}
                                <table id="table-to-xls" className="table table-bordered table-hover sm-text">
                                  {option === "excel" && (
                                    <>
                                      <tr style={{ border: "0px" }}>
                                        <th colSpan={Object.keys(reportData[0])?.length + 1} style={{ border: "0px" }}>
                                          {tableHeading()}
                                        </th>
                                      </tr>
                                    </>
                                  )}
                                  <tr></tr>
                                  <thead className="thead-light">
                                    <tr>
                                      {Object.keys(reportData[0]).map((key, index) => (
                                        <th style={{minWidth:"130px"}} key={index}>{key === "name" ? "Item Name" : key}</th>
                                      ))}
                                      <th style={{minWidth:"130px"}}>Diff</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {reportData.map((item, index) => {
                                      let diff = 0;
                                      return (
                                        <tr key={index}>
                                          {Object.keys(reportData[0]).map((key, kIndex) => {
                                            diff += getDiffAmount(key, item[key]);
                                            return <td key={kIndex}>{item[key]}</td>;
                                          })}
                                          <td>{Number.isInteger(diff) ? diff : diff.toFixed(3)}</td>
                                        </tr>
                                      );
                                    })}
                                    <tr></tr>
                                    <tr>
                                      {Object.keys(reportData[0]).map((key, kIndex) => {
                                        if (kIndex === 0) {
                                          return <th key={kIndex}>Total</th>;
                                        } else {
                                          const total = reportData.reduce((acc, curr) => acc + (parseFloat(curr[key]) || 0), 0);
                                          return <th key={kIndex}>{Number.isInteger(total) ? total : total.toFixed(2)}</th>;
                                        }
                                      })}
                                    </tr>
                                  </tbody>
                                </table>
                                </>
                              ) : (
                                <div className="text-center p-3">
                                  {_t(t("No data found"))}
                                </div>
                              )}
                            </div>
                          </div>
                        )
                      ) : (
                        <ReportExcelPrintGap
                          header={
                            reportOption === "summary" 
                              ? headerSummary 
                              : header
                          }
                          generatedReport={generatedReport}
                          heading={
                            reportOption === "summary" 
                              ? "Closing Stock Summary Report" 
                              : "Closing Stock Report"
                          }
                          reportData={reportData}
                          startDate={startDate}
                          endDate={endDate}
                          componentRef={componentRef}
                          printRef={componentRefThermal}
                          branch={{
                            name: (branch && branch.map((item) => item.name).join(", ")) ?? "All Branches",
                            show: true,
                            removeTotal: true
                          }}
                          type={option}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
    </>
  );
};

export default ClosingStockReport;
